import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseStoreFacade } from '@city/data-access';
import { MenuItemNested } from '@core/const';
import { MenuNestedService } from '@core/data-access';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class SdvorSocialLinksComponent implements OnInit {
  socialLinks$: Observable<MenuItemNested[]> = this.menuNestedService.getMenuBySlugValue('social-links');

  constructor(
    private menuNestedService: MenuNestedService,
    private baseStoreFacade: BaseStoreFacade,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.baseStoreFacade
      .getActiveCode()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((baseStoreCode) => {
        this.menuNestedService.loadMenuBySlug('social-links', baseStoreCode);
      });
  }
}
